module.exports = __webpack_public_path__ + "img/tv.aeb13bfe.svg";